import React from 'react'
import Link from 'gatsby-link'
import { TextStyles, Yummygum, Cleaner, Confetti } from '../images/'

export default() => (
  <footer className="main">
    <div className="container-md padding-xl">
      <div className="grid yg">
        <div className="col-4 plugin">
          <div className="logo">
            <img src={Confetti} alt="Text styles logo" />
          </div>
          <div className="desc">
            <h4>Sketch Confetti</h4>
            <p className="margin-s-bottom">Generate a gorgeous confetti pattern in Sketch with only one click. Easy peasy.</p>
            <a href="http://www.sketchconfetti.com/">
              Visit Sketch Confetti
              <svg width="14" height="13" viewBox="0 0 14 13" className="arrow-small">
                <path fill="#61B0FF" fillRule="evenodd" d="M10.0025141,5.49019646 L1.5067575,5.49019646 C0.918898812,5.49019646 0.458022899,5.96013849 0.458022899,6.53984136 C0.458022899,7.12358581 0.927557374,7.58948625 1.5067575,7.58948625 L10.0025141,7.58948625 L6.81014955,10.7818508 C6.41259629,11.179404 6.40841335,11.8308847 6.80765447,12.2301259 C7.20967904,12.6321504 7.85531045,12.6282499 8.25592957,12.2276308 L12.497939,7.98562137 L12.51726,8.00494239 L13.24015,7.28205238 C13.4594994,7.062703 13.558008,6.77083374 13.5371712,6.48580829 C13.5291364,6.23564962 13.4304925,5.98797284 13.24015,5.79763033 L12.51726,5.07474032 L12.497939,5.09406134 L8.25592957,0.852051922 C7.85837631,0.454498661 7.2068956,0.450315719 6.80765447,0.849556846 C6.40562991,1.25158141 6.40953043,1.89721282 6.81014955,2.29783194 L10.0025141,5.49019646 L10.0025141,5.49019646 Z"></path>
              </svg>
            </a>
          </div>
        </div>
        <div className="col-4 plugin">
          <div className="logo">
            <img src={Cleaner} alt="Cleaner logo" />
          </div>
          <div className="desc">
            <h4>Sketch Cleaner</h4>
            <p className="margin-s-bottom">Clean your Sketch files with a few clicks. Stay organized without the effort.</p>
            <a href="http://sketchcleaner.com/">
              Visit Sketch Cleaner
              <svg width="14" height="13" viewBox="0 0 14 13" className="arrow-small">
                <path fill="#61B0FF" fillRule="evenodd" d="M10.0025141,5.49019646 L1.5067575,5.49019646 C0.918898812,5.49019646 0.458022899,5.96013849 0.458022899,6.53984136 C0.458022899,7.12358581 0.927557374,7.58948625 1.5067575,7.58948625 L10.0025141,7.58948625 L6.81014955,10.7818508 C6.41259629,11.179404 6.40841335,11.8308847 6.80765447,12.2301259 C7.20967904,12.6321504 7.85531045,12.6282499 8.25592957,12.2276308 L12.497939,7.98562137 L12.51726,8.00494239 L13.24015,7.28205238 C13.4594994,7.062703 13.558008,6.77083374 13.5371712,6.48580829 C13.5291364,6.23564962 13.4304925,5.98797284 13.24015,5.79763033 L12.51726,5.07474032 L12.497939,5.09406134 L8.25592957,0.852051922 C7.85837631,0.454498661 7.2068956,0.450315719 6.80765447,0.849556846 C6.40562991,1.25158141 6.40953043,1.89721282 6.81014955,2.29783194 L10.0025141,5.49019646 L10.0025141,5.49019646 Z"></path>
              </svg>
            </a>
          </div>
        </div>
        <div className="col-4 plugin">
          <div className="logo">
            <img src={Yummygum} alt="Yummygum logo" />
          </div>
          <div className="desc">
            <h4>Yummygum</h4>
            <p className="margin-s-bottom">We help startups and businesses to refine, design and launch their digital products.</p>
            <a href="https://yummygum.com/">
              Visit Yummygum
              <svg width="14" height="13" viewBox="0 0 14 13" className="arrow-small">
                <path fill="#61B0FF" fillRule="evenodd" d="M10.0025141,5.49019646 L1.5067575,5.49019646 C0.918898812,5.49019646 0.458022899,5.96013849 0.458022899,6.53984136 C0.458022899,7.12358581 0.927557374,7.58948625 1.5067575,7.58948625 L10.0025141,7.58948625 L6.81014955,10.7818508 C6.41259629,11.179404 6.40841335,11.8308847 6.80765447,12.2301259 C7.20967904,12.6321504 7.85531045,12.6282499 8.25592957,12.2276308 L12.497939,7.98562137 L12.51726,8.00494239 L13.24015,7.28205238 C13.4594994,7.062703 13.558008,6.77083374 13.5371712,6.48580829 C13.5291364,6.23564962 13.4304925,5.98797284 13.24015,5.79763033 L12.51726,5.07474032 L12.497939,5.09406134 L8.25592957,0.852051922 C7.85837631,0.454498661 7.2068956,0.450315719 6.80765447,0.849556846 C6.40562991,1.25158141 6.40953043,1.89721282 6.81014955,2.29783194 L10.0025141,5.49019646 L10.0025141,5.49019646 Z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="credit-section">
      <p className="credits">
        Built with
        <span className="heart">
          <svg width="13" height="11" viewBox="0 0 13 11">
            <path fill="#8990AF" fillOpacity=".7" fillRule="evenodd" d="M7.29888015,2.23068754 L6.50970157,1.45849954 C5.20579703,0.182667327 3.08079315,0.178419862 1.77280798,1.45824484 C0.467484303,2.73546563 0.464939358,4.81319012 1.77306828,6.09315577 L7.29888015,11.5 L12.7817964,6.13512782 C14.1121406,4.83342519 14.1329375,2.73806982 12.8249523,1.45824484 C11.5196286,0.181024049 9.37698265,0.197325424 8.04516316,1.50047159 L7.29888015,2.23068754 Z" transform="translate(-.793 -.5)"></path>
          </svg>
        </span>
        by Yummygum — Copyright {new Date().getFullYear()}
      </p>
    </div>
  </footer>
)



// WEBPACK FOOTER //
// ./src/components/footer.js